import { jsx, jsxs } from "react/jsx-runtime";
import { filterDOMProps, mergeProps, useRouter, useLinkProps, shouldClientNavigate } from "@react-aria/utils";
import { $e6afbd83fe6ebbd2$export$4c014de7c8940b4c, $f6c31cce2adf654f$export$45712eceda6fad21 } from "../DateField/CalendarCell.mjs";
import { forwardRef, useRef } from "react";
import "../ThemeProvider/ThemeProvider.mjs";
import "../ThemePortal/ThemePortal.mjs";
import "../Text/TextContext.mjs";
import "../ThemeProvider/ThemeContext.mjs";
import "../ThemeProvider/VanillaThemeContainer.mjs";
import "../private/DefaultMessagesContext.mjs";
import "../ThemeProvider/BreakpointContext.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import { PublicBox } from "../Box/Box.mjs";
import { Stack } from "../Stack/Stack.mjs";
import "../Box/BackgroundContext.mjs";
import "../Divider/Divider.css.mjs";
import "../Accordion/AccordionContext.mjs";
import { Text } from "../Text/Text.mjs";
import { Columns } from "../Columns/Columns.mjs";
import { Column } from "../Column/Column.mjs";
import { Inline } from "../Inline/Inline.mjs";
import "../Heading/HeadingContext.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import "../private/touchable/virtualTouchable.css.mjs";
import "../private/hideFocusRings/hideFocusRings.css.mjs";
import "../Accordion/AccordionItem.css.mjs";
import "../Actions/ActionsContext.mjs";
import "../../css/textAlignedToIcon.css.mjs";
import "../Alert/Alert.css.mjs";
import "../Autosuggest/Autosuggest.mjs";
import "../Avatar/Avatar.css.mjs";
import "../Badge/Badge.mjs";
import "../../css/negativeMargin/negativeMargin.css.mjs";
import "../Breadcrumb/Breadcrumb.css.mjs";
import "../Box/ColoredBox.mjs";
import "../Button/Button.mjs";
import "../ButtonIcon/ButtonIcon.mjs";
import "../ButtonLink/ButtonLink.mjs";
import "../private/Keyline/Keyline.css.mjs";
import "../Checkbox/Checkbox.mjs";
import "../Checkbox/CheckboxStandalone.mjs";
import "../ContentBlock/ContentBlock.css.mjs";
import "../DateField/DateField.mjs";
import "../private/Field/FloatingLabel.css.mjs";
import "../private/Field/Field.css.mjs";
import "../DateField/DateField.css.mjs";
import "../private/Modal/Modal.mjs";
import "../private/Modal/ModalContent.mjs";
import "../private/Modal/ModalContext.mjs";
import "../TextLink/TextLink.mjs";
import "../TextLinkButton/TextLinkButton.css.mjs";
import "../private/AvoidWidowIcon/AvoidWidowIcon.css.mjs";
import "../Dropdown/Dropdown.mjs";
import "../private/MaxLines/MaxLines.css.mjs";
import "../Hidden/Hidden.css.mjs";
import "../HiddenVisually/HiddenVisually.css.mjs";
import "../Link/Link.mjs";
import "../private/defaultTextProps.mjs";
import "../List/List.css.mjs";
import "../Loader/Loader.css.mjs";
import "../Skeleton/Skeleton.css.mjs";
import "../MenuRenderer/MenuRenderer.mjs";
import "../MenuItem/MenuItem.mjs";
import "../MenuItemCheckbox/MenuItemCheckbox.mjs";
import "../MenuItemDivider/MenuItemDivider.mjs";
import "../MenuItem/MenuItemLink.mjs";
import "../OverflowMenu/OverflowMenu.css.mjs";
import "../MonthPicker/MonthPicker.mjs";
import "../Pagination/Pagination.css.mjs";
import "../PasswordField/PasswordField.mjs";
import "../Pincode/Pincode.mjs";
import "../PopoverRenderer/PopoverRenderer.mjs";
import "../Pressable/Pressable.mjs";
import "../RadioGroup/RadioGroup.mjs";
import "../RadioGroup/RadioItem.mjs";
import "../RadioGroup/RadioItemBlock.mjs";
import "../SelectableList/SelectableList.css.mjs";
import "../private/BulkActions/BulkActions.css.mjs";
import "../Spread/Spread.css.mjs";
import "../Stepper/Step.mjs";
import "../Stepper/Stepper.mjs";
import "../Tabs/Tab.mjs";
import "../Table/Table.mjs";
import "../Table/Table.css.mjs";
import "../Tabs/TabsProvider.mjs";
import "../Tabs/TabListContext.mjs";
import "../Tabs/Tabs.css.mjs";
import "../Tabs/TabPanelsContext.mjs";
import "../Tag/Tag.css.mjs";
import "../Textarea/Textarea.mjs";
import "../TextDropdown/TextDropdown.css.mjs";
import "../TextField/TextField.mjs";
import "../Tiles/Tiles.css.mjs";
import "../Toggle/Toggle.mjs";
import "../useToast/ToastContext.mjs";
import "../TooltipRenderer/TooltipRenderer.mjs";
import "../TimeField/DateSegment.css.mjs";
import "../private/FieldButtonIcon/FieldButtonIcon.mjs";
import "../MultiStepModal/MultiStepModal.mjs";
import "../SearchField/SearchField.mjs";
import "../RadioBar/RadioBarContext.mjs";
import "../RadioBar/RadioBar.css.mjs";
import "../../themes/vars.css.mjs";
import "../RadioBar/RadioBar.mjs";
function $298d61e98472621b$export$dcf14c9974fe2767(props, ref) {
  let {
    elementType = "a",
    onPress,
    onPressStart,
    onPressEnd,
    // @ts-ignore
    onClick: deprecatedOnClick,
    isDisabled,
    ...otherProps
  } = props;
  let linkProps = {};
  if (elementType !== "a") linkProps = {
    role: "link",
    tabIndex: !isDisabled ? 0 : void 0
  };
  let { focusableProps } = $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, ref);
  let { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
    onPress,
    onPressStart,
    onPressEnd,
    isDisabled,
    ref
  });
  let domProps = filterDOMProps(otherProps, {
    labelable: true
  });
  let interactionHandlers = mergeProps(focusableProps, pressProps);
  let router = useRouter();
  let routerLinkProps = useLinkProps(props);
  return {
    isPressed,
    linkProps: mergeProps(domProps, routerLinkProps, {
      ...interactionHandlers,
      ...linkProps,
      "aria-disabled": isDisabled || void 0,
      "aria-current": props["aria-current"],
      onClick: (e) => {
        var _pressProps_onClick;
        (_pressProps_onClick = pressProps.onClick) === null || _pressProps_onClick === void 0 ? void 0 : _pressProps_onClick.call(pressProps, e);
        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn("onClick is deprecated, please use onPress");
        }
        if (!router.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
        !e.isDefaultPrevented() && shouldClientNavigate(e.currentTarget, e) && props.href) {
          e.preventDefault();
          router.open(e.currentTarget, e, props.href, props.routerOptions);
        }
      }
    })
  };
}
const SelectFieldList = forwardRef((props, ref) => {
  const linkRef = useRef(null);
  const { linkProps } = $298d61e98472621b$export$dcf14c9974fe2767(
    {
      onPress: props.onClick,
      isDisabled: props.disabled,
      elementType: props.href ? "a" : "div"
    },
    linkRef
  );
  return /* @__PURE__ */ jsx(PublicBox, { ref, as: "li", disabled: props.disabled, children: /* @__PURE__ */ jsx(
    PublicBox,
    {
      ref: linkRef,
      href: props.href,
      target: props.target,
      display: "block",
      ...linkProps,
      tabIndex: !props.ignoreTabIndex ? linkProps.tabIndex : void 0,
      onClick: props.onClick,
      children: /* @__PURE__ */ jsx(PublicBox, { paddingX: "xsmall", paddingY: "xsmall", children: /* @__PURE__ */ jsxs(PublicBox, { display: "flex", children: [
        renderLeft(props),
        renderContent(props),
        renderRight(props)
      ] }) })
    }
  ) }, props.key);
});
function renderLeft(props) {
  if (props.icon) {
    return /* @__PURE__ */ jsx(Column, { width: "content", children: props.icon });
  }
  return null;
}
function renderRight(props) {
  if (props.trailingIcon) {
    return /* @__PURE__ */ jsx(Column, { width: "content", children: props.trailingIcon });
  }
  return null;
}
function renderContent(props) {
  if (props.tertiaryLabel) {
    return /* @__PURE__ */ jsx(SingleLineWithTertiary, { ...props });
  } else if (props.secondaryLabel) {
    return /* @__PURE__ */ jsx(TwoLine, { ...props });
  }
  return /* @__PURE__ */ jsx(SingleLine, { ...props });
}
function SingleLine(props) {
  return /* @__PURE__ */ jsx(
    Text,
    {
      weight: props.isSelected ? "strong" : "regular",
      tone: props.disabled ? "disabled" : "neutral",
      children: props.label
    }
  );
}
function TwoLine(props) {
  return /* @__PURE__ */ jsxs(Stack, { space: "xsmall", align: "left", children: [
    /* @__PURE__ */ jsx(
      Text,
      {
        weight: props.isSelected ? "strong" : "regular",
        tone: props.disabled ? "disabled" : "neutral",
        children: props.label
      }
    ),
    /* @__PURE__ */ jsx(Text, { size: "small", tone: props.disabled ? "disabled" : "neutral", children: props.secondaryLabel })
  ] });
}
function SingleLineWithTertiary(props) {
  return /* @__PURE__ */ jsx(PublicBox, { width: "full", children: /* @__PURE__ */ jsxs(Columns, { space: "xsmall", align: "left", children: [
    /* @__PURE__ */ jsx(Column, { width: "2/3", children: /* @__PURE__ */ jsxs(Inline, { align: "left", space: "xsmall", alignY: "center", children: [
      /* @__PURE__ */ jsx(
        Text,
        {
          weight: props.isSelected ? "strong" : "regular",
          tone: props.disabled ? "disabled" : "neutral",
          children: props.label
        }
      ),
      props.secondaryLabel ? /* @__PURE__ */ jsx(Text, { tone: props.disabled ? "disabled" : "positive", children: props.secondaryLabel }) : null
    ] }) }),
    /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(Inline, { align: "right", space: "xsmall", children: /* @__PURE__ */ jsx(Text, { tone: props.disabled ? "disabled" : "neutral", weight: "medium", children: props.tertiaryLabel }) }) })
  ] }) });
}
export {
  SelectFieldList
};
